import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionKey, PermissionRow } from '../../../modules/shared/models/roles.modal';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
@Component({
  selector: 'app-permission-matrix',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './permission-matrix.component.html',
  styleUrl: './permission-matrix.component.scss'
})
export class PermissionMatrixComponent {
   @Input() rows: PermissionRow[] = [];
   @Input() disable:boolean = false;
   @Input() action!: string;
  @Output() rowsChange = new EventEmitter<PermissionRow[]>();

  readonly columns: PermissionKey[] = ['view', 'create', 'edit', 'approve', 'delete'];

  togglePermission(rowIndex: number, key: PermissionKey): void {
    this.rows[rowIndex].permissions[key] = !this.rows[rowIndex].permissions[key];
    this.rowsChange.emit([...this.rows]);
  }

  isAllChecked(row: PermissionRow): boolean {
    return this.columns.every(col => row.permissions[col]);
  }

  toggleAll(rowIndex: number): void {
    const shouldCheck = !this.isAllChecked(this.rows[rowIndex]);
    this.columns.forEach(col => {
      this.rows[rowIndex].permissions[col] = shouldCheck;
    });
    this.rowsChange.emit([...this.rows]);
  }

  trackByModule(_: number, row: PermissionRow): string {
    return row.module;
  }
}
